import type { Messages } from './en.js';

/** Simplified Chinese. Traditional-script tags (zh-TW, zh-HK) also resolve here: the primary subtag is `zh`. */
export const zh: Messages = {
  'app.title': 'Sync Port · 点对点文件传输',
  'secure.badge': '端到端加密 · 设备直连 · 服务器不保存任何内容',
  'secure.tooltip': 'WebRTC 数据通道在两台设备之间以 DTLS 加密。服务器和 TURN 中继只能看到密文。',
  'error.title': '连接中断',
  'error.peerFailed': '直接连接失败。请检查网络或 TURN 中继的配置。',
  'error.signaling': '无法连接到信令服务器。',
  'error.roomNotFound': '没有与此链接或 PIN 码匹配的传输。发送方可能已关闭页面，也可能是输入有误。',
  'error.roomFull': '已经有其他人打开了此链接。每个链接只能供一位接收方使用。',
  'notFound.tagline': '这片坐标是一段虚空。',
  'notFound.text': '你打开的页面不存在。',
  'notFound.action': '发送文件',
  'action.startOver': '重新开始',
  'action.retry': '重试',
  'action.cancel': '取消',
  'action.dismiss': '关闭',
  'sender.tagline': '通过私密的加密链接在设备之间传送文件。轨道上不留存任何数据。',
  'drop.title': '选择要传送的文件',
  'drop.hint': '点击或把文件拖到这里 · 不限大小',
  'share.title': '分享此链接',
  'share.text': '在另一台设备上打开它，或用手机相机扫描二维码。',
  'share.linkLabel': '分享链接',
  'share.copy': '复制链接',
  'share.native': '分享…',
  'share.or': '或',
  'share.pinHint': '在另一台设备的首页输入此 PIN 码。',
  'share.pinLabel': '传输 PIN 码',
  'share.copied': '已复制到剪贴板',
  'share.shared': '已分享',
  'share.linkMessage': '打开此链接即可接收我发送的文件：',
  'share.unavailable': '此浏览器没有系统分享面板。',
  'clipboard.blocked': '此浏览器阻止了复制。请选中链接并手动复制。',
  'pin.title': '有 PIN 码或二维码？',
  'pin.text': '输入发送设备上显示的 9 位数字，或扫描它的二维码。',
  'pin.receive': '接收',
  'pin.scan': '📷 改用扫描二维码',
  'pin.incomplete': '请输入 PIN 码的全部 {count} 位数字。',
  'scan.hint': '把相机对准发送设备上的二维码',
  'scan.notOurs': '这不是 Sync Port 的链接。请继续寻找发送设备上的那个二维码。',
  'camera.denied': '相机权限被拒绝。请在浏览器设置中允许，或改为输入 PIN 码。',
  'camera.notFound': '此设备上没有找到相机。',
  'camera.busy': '相机正被其他应用占用。',
  'camera.failed': '无法打开相机（{reason}）。',
  'sender.status.creatingRoom': '正在创建私密房间',
  'sender.status.waitingReceiver': '等待接收方打开链接',
  'sender.status.receiverConnected': '接收方已连接，正在建立加密的直连通道',
  'sender.status.waitingDestination': '加密通道已建立。等待接收方选择保存位置',
  'sender.status.beaming': '正在穿越星海传送文件',
  'sender.status.delivered': '已送达',
  'status.failed': '传输失败',
  'progress.sending': '正在发送',
  'progress.receiving': '正在接收',
  'progress.sentDetail': '已发送 {sent} · 接收方已确认 {acked}',
  'progress.deliveredDetail': '接收方已拿到完整文件。',
  'progress.arrivedDetail': '每一个字节都已抵达。',
  'progress.of': '{done} / {total}',
  'progress.speedEta': '{speed} · 剩余 {eta}',
  'route.finding': '正在寻找最佳路径',
  'route.direct': '直接连接',
  'route.nat': '穿越 NAT 的直接连接',
  'route.relay': '通过 TURN 中继',
  'route.relayOver': '通过 TURN 中继（{protocol}）',
  'sender.sendAnother': '再发送一个文件',
  'receiver.tagline': '正通过私密的加密链接接收传输。文件落地之前请保持此页面打开。',
  'receiver.status.contacting': '正在联系发送方',
  'receiver.status.connected': '已连接到发送方，正在建立加密的直连通道',
  'receiver.status.channelOpen': '加密通道已建立，正在等待文件信息',
  'receiver.status.chooseDestination': '选择保存位置即可开始接收',
  'receiver.status.receiving': '正在接收',
  'receiver.status.complete': '已完成',
  'dest.title': '准备接收',
  'dest.picker.button': '选择保存位置',
  'dest.picker.text': '即将传入 {size}。选好位置后，文件会直接写入其中。',
  'dest.worker.button': '保存到此设备',
  'dest.worker.text': '即将传入 {size}。文件会边接收边写入你的下载文件夹。',
  'dest.memory.button': '接收文件',
  'dest.memory.text': '即将传入 {size}。此浏览器会先把文件留在标签页里，之后再由你保存。',
  'dest.cancelled': '请选择保存位置以开始接收。',
  'landed.title': '安全着陆',
  'landed.chosenFolder': '已保存为 {name}，就在你选择的文件夹里。',
  'landed.downloads': '已保存到浏览器的下载文件夹。',
  'landed.openWith': '打开方式…',
  'landed.sendYourself': '我也要发送文件',
  'memory.received': '已收到 {size}。请把它保存到此设备。',
  'memory.save': '保存文件',
  'memory.saved': '已保存到浏览器的下载文件夹。你也可以立即用其他应用打开它。',
  'memory.saveAgain': '再次保存',
  'error.inboxNotFound': '此收件箱号码不存在。',
  'error.inboxUnauthorized': '密钥与此收件箱不匹配。',
  'error.declined': '收件箱的主人拒绝了这个文件。',
  'error.inboxLimit': '此服务器已无法再创建收件箱。',
  'home.inboxLink': '创建收件箱',
  'inbox.tagline': '你的永久收件箱。任何扫码的人都可以给你发来文件，接收哪些由你决定。',
  'inbox.create.title': '创建收件箱',
  'inbox.create.text': '获得一个永久号码和二维码。扫码的人可以给你发来文件；在你接受之前，什么都不会传入。',
  'inbox.create.button': '创建我的收件箱',
  'inbox.connect.title': '已经有收件箱了？',
  'inbox.connect.text': '粘贴密钥即可在此设备上使用该收件箱。号码可以不填：它能从密钥中找回。',
  'inbox.connect.numberOptional': '收件箱号码（可选）',
  'error.keyUnknown': '没有与此密钥匹配的收件箱。',
  'inbox.connect.number': '收件箱号码',
  'inbox.connect.key': '密钥',
  'inbox.connect.button': '连接',
  'inbox.key.title': '你的密钥',
  'inbox.key.text': '请把号码和密钥一起妥善保管。密钥只在这里显示这一次，它和号码是在其他设备上打开此收件箱的唯一途径。',
  'inbox.key.copy': '复制号码和密钥',
  'inbox.key.copied': '号码和密钥已复制',
  'inbox.key.done': '我已保存好',
  'inbox.number.title': '你的收件箱号码',
  'inbox.number.text': '把这个二维码打印出来，或显示在屏幕上。顾客扫描它，或在首页输入号码。',
  'inbox.status.connecting': '正在连接你的收件箱',
  'inbox.status.online': '在线。等待顾客',
  'inbox.status.reconnecting': '连接已断开。正在重新连接',
  'inbox.requests.title': '收到的请求',
  'inbox.requests.empty': '还没有请求。顾客一发送文件，请求就会出现在这里。',
  'inbox.request.accept': '接受并保存…',
  'inbox.request.decline': '拒绝',
  'inbox.request.connecting': '已接受。正在连接顾客',
  'inbox.request.cancelled': '顾客在你回应之前就离开了。',
  'inbox.refresh': '刷新',
  'inbox.forget': '在此设备上忘记这个收件箱',
  'toInbox.tagline': '向收件箱 {number} 发送文件。它的主人会看到你的请求并作出决定。',
  'toInbox.status.announcing': '正在向收件箱通报你的文件',
  'toInbox.status.waitingOnline': '已送达收件箱。等待批准',
  'toInbox.status.waitingOffline': '收件箱的主人现在不在线。你的请求会一直等到他们回来',
  'toInbox.status.accepted': '已接受。正在建立加密的直连通道',
  'inbox.print': '打印海报（PDF）',
  'poster.title': '把文件发给我',
  'poster.number': '收件箱号码',
  'poster.step1': '用手机相机扫描二维码。',
  'poster.step2': '或者打开 {link} 并输入号码。',
  'poster.step3': '选好文件。我们就在柜台这里接收。',
  'poster.footer': 'Sync Port · 端到端加密，设备直连。服务器不保存任何内容。',
  'install.title': '安装 Sync Port',
  'install.native': '把它添加到主屏幕，随时快速打开。',
  'install.ios': '点击“分享”，然后选择“添加到主屏幕”。',
  'install.button': '安装',
};
